import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

export default () => ({
  swiper: null,

  init() {
    this.swiper = new Swiper(this.$refs.swiper, {
      modules: [Navigation],

      slidesPerView: 1.1,
      spaceBetween: 20,
      loop: false,

      breakpoints: {
        768: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 3.4,
        },
      },

      navigation: {
        nextEl: this.$refs.next,
        prevEl: this.$refs.prev,
      },
    });
  },
});